export const examples = {
  dataFieldsExampleCreateOrder: [
    {
      fieldName: 'Customer Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Product Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Delivery Time',
      tags: '',
      exampleData: ['Example datetime', 'Example datetime', 'Example datetime']
    },
    {
      fieldName: 'Delivery Address',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Quantity',
      tags: '',
      exampleData: ['x', 'y', 'z']
    },
    {
      fieldName: 'Comment',
      tags: '',
      exampleData: ['Example comment', 'Example comment', 'Example comment']
    }
  ],
  dataFieldsExampleDeliverOrder: [
    {
      fieldName: 'Supplier',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Product Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Delivery Time',
      tags: '',
      exampleData: ['Example datetime', 'Example datetime', 'Example datetime']
    },
    {
      fieldName: 'Delivery Address',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Quantity',
      tags: 'REQUIRED',
      exampleData: ['x', 'y', 'z']
    },
    {
      fieldName: 'Shipping Method',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    }
  ],
  readModelExampleCreateOrder: [
    {
      fieldName: 'Customer',
      exampleData: ['John Doe', 'Jane Smith', 'Alice Brown']
    },
    {
      fieldName: 'Order',
      exampleData: ['Pending', 'Shipped', 'Delivered']
    },
    {
      fieldName: 'Delivery Location',
      exampleData: ['Warehouse A', 'Warehouse B', 'Warehouse C']
    }
  ],
  customerDimensionTableExample: [
    {
      fieldName: 'Customer ID',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data'],
      primaryKey: true
    },
    {
      fieldName: 'Customer Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Customer Address',
      tags: '',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Phone Number',
      tags: '',
      exampleData: ['Example data', 'Example data', 'Example data']
    }
  ],
  productDimensionTableExample: [
    {
      fieldName: 'Product ID',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data'],
      primaryKey: true
    },
    {
      fieldName: 'Product Name',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Product Type',
      tags: 'REQUIRED',
      exampleData: ['Example data', 'Example data', 'Example data']
    },
    {
      fieldName: 'Stock Level',
      tags: '',
      exampleData: ['x', 'y', 'z']
    }
  ]
}
